import {
  ConfigProvider,
  ErrorComponent,
  Layout,
  notificationProvider,
  ReadyPage,
} from "@pankod/refine-antd";
import "@pankod/refine-antd/dist/styles.min.css";
import { I18nProvider, Refine } from "@pankod/refine-core";
import routerProvider from "@pankod/refine-react-router-v6";

// Ajustes no tema
import { Title } from "components";
import { UserMenu } from "components/user-menu";
import { ThemeProvider } from "contexts/ThemeContext";
import "styles/antd.less";

import { authProvider } from "authProvider";
import { dataProvider } from "dataProvider";
import { HomePage } from "pages/home";
import { LoginPage } from "pages/login";
import { resourcesProvider } from "resourcesProvider";

import ptBR from "antd/es/locale/pt_BR";
import { useTranslation } from "react-i18next";

import { ptBrOverrides } from "i18n/pt-br";
import { axiosInstance } from "services/axios";

function App() {
  const { t, i18n } = useTranslation();

  const i18nProvider: I18nProvider = {
    translate: (key: string, options?: any): any =>
      ptBrOverrides[key] || t(key, options),
    changeLocale: (lang: string) => i18n.changeLanguage(lang),
    getLocale: () => i18n.language,
  };

  return (
    <ConfigProvider locale={ptBR}>
      <ThemeProvider>
        <Refine
          notificationProvider={notificationProvider}
          Layout={Layout}
          Title={Title}
          Header={UserMenu}
          DashboardPage={HomePage}
          LoginPage={LoginPage}
          ReadyPage={ReadyPage}
          catchAll={<ErrorComponent />}
          routerProvider={routerProvider}
          dataProvider={dataProvider(axiosInstance)}
          authProvider={authProvider(axiosInstance)}
          resources={resourcesProvider()}
          options={{ disableTelemetry: true }}
          i18nProvider={i18nProvider}
        />
      </ThemeProvider>
    </ConfigProvider>
  );
}

export default App;
